import { render, staticRenderFns } from "./SchoolInfomation.vue?vue&type=template&id=2ed11df6&scoped=true"
import script from "./SchoolInfomation.vue?vue&type=script&lang=js"
export * from "./SchoolInfomation.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfomation.vue?vue&type=style&index=0&id=2ed11df6&prod&lang=css"
import style1 from "./SchoolInfomation.vue?vue&type=style&index=1&id=2ed11df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed11df6",
  null
  
)

export default component.exports